import { TerminalError } from "@/utils/UTerminal";

import { TCommandArg } from "@/types";

export const numberArg = (
	props?: Partial<TCommandArg>,
	errorMessage: string = "invalidNumber"
): TCommandArg => ({
	name: "number",
	description: "A number",
	check: (value) => {
		if (isNaN(Number(value))) {
			throw new TerminalError(errorMessage, {
				value,
			});
		}
		return true;
	},
	...props,
});
